import { TrackingStoreType } from "UidispatcherApiModule";
const { TrackingStore }: { TrackingStore: TrackingStoreType } =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export default TrackingStore;
